import React, { useEffect } from 'react';
import './App.css';
import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";
import Login, { config } from './components/Login';
import ProtectedRoute, { getIdToken } from './ProtectedRoute';
import { ConfigProvider, Layout } from 'antd';
import store from "./redux";
import { storeUserError, storeUser } from './AuthActions';
import PageNotFound from './components/PageNotFound';
import { Provider } from 'react-redux';
import AuthProvider from './AuthProvider';
import SigninOidc from './signin-oidc';
import SignoutOidc from './signout-oidc';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Accounts from './components/Accounts/Accounts';
import Users from './components/Users/Users';
import { applicationSelectionColour } from './components/MainLayout/MainHeader';

const clientId = String(localStorage.getItem("clientId"));
const issuer = String(localStorage.getItem("issuer"));
export const idpType = String(localStorage.getItem("idpType"));
const webStorageStore = new WebStorageStateStore({ store: window.localStorage })

export const userManager = new UserManager(config(issuer, clientId, idpType, webStorageStore));

export function isAuthenticated() {
	return !!localStorage.getItem(`oidc.user:${localStorage.getItem('issuer')}:${localStorage.getItem('clientId')}`)
}

export function signoutRedirectCallback() {
	userManager.clearStaleState()
	userManager.removeUser()
	return userManager.signoutRedirectCallback()
}

export function signinRedirectCallback() {
	return userManager.signinRedirectCallback()
}

export const signout = async () => {
	const logoutUrl = localStorage.getItem("logout_url") ?? ""
	try {
		if (issuer?.includes("cognito")) {
			window.location.replace(`${logoutUrl}?client_id=${clientId}&logout_uri=${window.location.origin}/logout/callback`)
		}
		else {
			userManager.signoutRedirect({ id_token_hint: getIdToken() });
		}
	}
	catch (error) {
		console.error(error)
	}
}

function App() {
	useEffect(() => {
		const fetchUser = async () => {
			try {
				const user = await userManager.getUser();
				store.dispatch((!user) ? storeUserError() : storeUser(user))
			} catch (e) {
				console.error(`User not found: ${e}`);
				store.dispatch(storeUserError());
			}
		};

		fetchUser();
	}, [])

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: applicationSelectionColour,
					borderRadius: 4,
				},
				components: {
					Modal: {
						borderRadiusLG: 10,   // main modal border radius
					},
				},
			}}
			componentSize="large"
		>
			<Provider store={store}>
				<AuthProvider userManager={userManager} store={store}>
					<Router>
						<Switch>
							<Route path="/" exact component={Login} />
							<Route path="/login/callback" component={SigninOidc} />
							<Route path="/logout/callback" component={SignoutOidc} />
							<ProtectedRoute path="/accounts" component={Accounts} />
							<ProtectedRoute path="/admins" component={Users} />
							<Route component={PageNotFound} />
						</Switch>
					</Router>
				</AuthProvider>
			</Provider>
		</ConfigProvider>
	);
}

export default App;
